import { Injectable } from '@angular/core';

export interface IGeolocationPosition {
  latitude: number;
  longitude: number;
}
export interface IGeolocationService {
  hasGeocodeMethod(): boolean;
  geocode(address: string): Promise<IGeolocationPosition>;
}
export interface IWaitingStateService {
  initAction(id: string): void;
  endAction(id: string): void;
}

@Injectable({
  providedIn: 'root',
})
export class InteractionsService
  implements IWaitingStateService, IGeolocationService
{
  private waitingStateService: IWaitingStateService;
  private geolocationService: IGeolocationService;

  constructor() {}
  public registerWaitingStateService(
    waitingStateService: IWaitingStateService
  ) {
    this.waitingStateService = waitingStateService;
  }
  public registerGeolocationService(geolocationService: IGeolocationService) {
    this.geolocationService = geolocationService;
  }
  hasGeocodeMethod(): boolean {
    return (
      this.geolocationService && this.geolocationService.hasGeocodeMethod()
    );
  }
  geocode(address: string): Promise<IGeolocationPosition> {
    if (!this.hasGeocodeMethod()) {
      throw new Error('Method not implemented.');
    }
    return this.geolocationService.geocode(address);
  }
  initAction(id: string): void {
    if (this.waitingStateService) {
      this.waitingStateService.initAction(id);
    }
  }
  endAction(id: string): void {
    if (this.waitingStateService) {
      this.waitingStateService.endAction(id);
    }
  }
}
